export enum ROLE {
  ALL = 'all',
  ADMIN = 'admin',
  MANAGER = 'manager',
  PROMOTER = 'promoter',
  SUPER_ADMIN = 'super_admin',
  CLIENT = 'client',
}
